import React, { useEffect } from 'react'
import { PhoneInput } from '@paypalcorp/pp-react'
import { trackClick, trackError } from 'ppbl/utils/fpti-helper'

const PhoneInputAdapter = ({ input, meta, fptiPage, ...rest }) => {
  const handleChange = (event) => {
    input.onChange(event.target.value)
  }
  const handleFocus = () => {
    trackClick({
      page: fptiPage,
      component: input.name,
      link: input.name,
    })
  }

  useEffect(() => {
    if (meta.touched && meta.error) {
      trackError({
        page: fptiPage,
        error: meta.error,
        component: input.name,
        link: input.name,
      })
    }
  }, [meta.error, meta.touched])

  return (
    <PhoneInput
      {...input}
      {...rest}
      onChange={handleChange}
      onFocus={handleFocus}
      errorText={meta.touched ? meta.error : ''}
    />
  )
}

export default PhoneInputAdapter
